<div
  class="sidebar-navitem pointer smooth-transition"
  (click)="menuItemTriggered()"
>
  <div class="nav-title pave-text" [ngClass]="navStyle">{{ navTitle }}</div>
  <mat-icon *ngIf="menuOptions.length">chevron_right</mat-icon>
</div>
